import { GET_PROFILE } from "../configs/routes.js";
import api from "./api.js";

export const getProfile = () =>
  new Promise((resolve, reject) => {
    api
      .get(GET_PROFILE, {})
      .then((response) => resolve(response.data))
      .catch((err) => reject(err));
  });
